import { ActivityCode } from '@app/AppConstants/ActivityCode';
import DateTimeService from './DateTimeService';

type HoursModel = {
    from: number,
    to: number
}

export class FreelanceActivityService {
    public getFromLt(activityCode: ActivityCode, date: Date) {
        let hours = this._getHours(activityCode);
        return DateTimeService.withTime(date, hours.from, 0);
    }

    public getToLt(activityCode: ActivityCode, date: Date) {
        let hours = this._getHours(activityCode);
        return DateTimeService.withTime(date, hours.to, 0);
    }

    public getFromUtc(activityCode: ActivityCode, date: Date) {
        return DateTimeService.getUtcDate(this.getFromLt(activityCode, date));
    }

    public getToUtc(activityCode: ActivityCode, date: Date) {
        return DateTimeService.getUtcDate(this.getToLt(activityCode, date));
    }

    private _getHours(activityCode: ActivityCode): HoursModel {
        switch (activityCode) {
            case ActivityCode.A_N:
            case ActivityCode.FA_N:
                return {
                    from: 0,
                    to: 24 + 8
                };
            case ActivityCode.AE_:
            case ActivityCode.FAE_:
                return {
                    from: 4,
                    to: 15
                };
            case ActivityCode.AL_:
            case ActivityCode.FAL_:
                return {
                    from: 11,
                    to: 24
                };
            case ActivityCode.AN_:
            case ActivityCode.FAN_:
                return {
                    from: 20,
                    to: 24 + 8
                };
            default:
                return {
                    from: 0,
                    to: 0
                };
        }
    }
}
